const styles = theme => ({
  portalShell: {position:"sticky",top:"calc(-1 * var(--portal-brand-height, 0px))",zIndex:1200,[theme.breakpoints.down("md")]:{top:0}},
  portalMasthead: {display:"flex",gap:16,minHeight:72,padding:"12px 24px",boxSizing:"border-box",[theme.breakpoints.down("md")]:{gap:8,minHeight:64,padding:"10px 16px"}},
  portalBrand: {display:"flex",alignItems:"center",gap:12,flex:1,minWidth:0},
  portalBrandName: {color:"#fff",fontFamily:'"Barlow Condensed",sans-serif',fontWeight:700,fontSize:"1.35rem",lineHeight:1.1,textTransform:"uppercase",[theme.breakpoints.down("sm")]:{display:"none"}},
  portalBranchGroup: {display:"flex",alignItems:"center",gap:12,flexShrink:0},
  portalBranchTime: {color:"#d2dff5",fontSize:"0.75rem",whiteSpace:"nowrap",[theme.breakpoints.down("md")]:{display:"none"}},
  portalAccountButton: {color:"#fff",border:"1px solid #ffffff40",flexShrink:0,[theme.breakpoints.down("md")]:{display:"none"}},
  portalMobileMenu: {color:"#fff",display:"none",[theme.breakpoints.down("md")]:{display:"inline-flex"}},
  portalNavigationRow: {display:"flex",alignItems:"center",flexWrap:"wrap",justifyContent:"flex-end",gap:8,padding:"8px 24px",background:"#10367f",borderTop:"1px solid #ffffff20",[theme.breakpoints.down("md")]:{padding:0,borderTop:0,"& > [role=status]":{margin:"0 16px 10px",width:"calc(100% - 32px)"}}},
  portalNavigation: {display:"flex",justifyContent:"flex-end",gap:8,[theme.breakpoints.down("md")]:{display:"none"}},
  portalNavItem: {color:"#e4edfc",fontFamily:'"Manrope",sans-serif',fontSize:"0.88rem",fontWeight:700,padding:"10px 18px",borderRadius:24,textDecoration:"none",whiteSpace:"nowrap",display:"block","&:hover":{background:"#ffffff18"},"&:focus-visible":{outline:"2px solid #fff",outlineOffset:2}},
  portalNavActive: {background:"#3662a7",color:"#fff",boxShadow:"inset 0 0 0 1px #ffffff38"},
  root: {
    position: "relative",
    zIndex: 10,
  },
  logo: {
    width: '100%',
  },
  logoIcon: {
    background: "rgba(255, 255, 255, 0.96)",
    borderRadius: 16,
    padding: theme.spacing(0.6),
    width: 64,
    flex: "0 0 auto",
  },
  headerBar: {
    paddingRight: '50px',
  },
  navHeader: {
    marginTop: '40px',
  },
  header: {
    borderBottom: '1px solid #FFFFFF',
  },
  title: {
    flexGrow: "1",
  },
  privateHeader: {
    background: "linear-gradient(180deg, rgba(19, 63, 144, 1) 0%, rgba(16, 54, 127, 1) 100%)",
    boxShadow: "none",
    borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
  },
  privateToolbar: {
    display: "flex",
    flexWrap: "wrap",
    boxSizing: "border-box",
    width: "100%",
    gap: theme.spacing(2),
    minHeight: "auto",
    paddingBottom: theme.spacing(1.6),
    paddingTop: theme.spacing(1.6),
  },
  privateBrand: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1.5),
    minWidth: 0,
    flexGrow: 1,
  },
  privateTitle: {
    color: "#FFFFFF",
    fontFamily: '"Barlow Condensed", sans-serif',
    fontWeight: 600,
    letterSpacing: "0.02em",
    lineHeight: 1,
    textTransform: "uppercase",
  },
  headerLine: {
    height: '5px',
    borderTop: '1px solid #FFFFFF',
  },
  headerLineSignup: {
    height: '5px',
    borderTop: '1px solid #FFFFFF',
    marginTop: '20px',
  },
  gretting: {
    marginTop: '100px',
    marginLeft: '48px',
  },
  grettingText: {
    color: 'var(--wws-primary)',
    fontWeight: 'bold'
  },
  signupText: {
    paddingTop: '40px',
    paddingLeft: '20px',
    color: 'var(--wws-primary)',
    fontWeight: '700',
  },
  navLink: {
    flexShrink: 0,
    textDecoration: 'none',
  },
  navLinkText: {
    color: "rgba(255, 255, 255, 0.92)",
    fontFamily: '"Barlow Condensed", sans-serif',
    fontWeight: 600,
    letterSpacing: "0.03em",
    marginLeft: '10px',
    [theme.breakpoints.up('md')]: {
      marginLeft: '22px',
    },
    [theme.breakpoints.up('lg')]: {
      marginLeft: '28px',
    },
  },

  button: {
    margin: theme.spacing(1),
    background: 'var(--wws-primary)',
    color: 'var(--wws-paper)',
    fontWeight: '700',
    marginTop: '40px',
  },
  logInButtonDiv: {
    marginTop: '64px',
  },
  contactButtonDiv: {
    marginTop: '64px',
  },
  link: {
    textDecoration: 'none',
  },
  publicHeader: {
    background: "linear-gradient(180deg, rgba(19, 63, 144, 1) 0%, rgba(16, 54, 127, 1) 100%)",
    boxShadow: "none",
  },
  publicToolbar: {
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "space-between",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  publicBrand: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  publicLogoIcon: {
    background: "rgba(255, 255, 255, 0.96)",
    borderRadius: 16,
    padding: theme.spacing(0.6),
    width: 64,
  },
  publicTitle: {
    color: "#FFFFFF",
    fontFamily: '"Barlow Condensed", sans-serif',
    fontWeight: 600,
    letterSpacing: "0.02em",
    lineHeight: 1,
    textTransform: "uppercase",
  },
  publicNav: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(3),
    marginLeft: "auto",
  },
  publicNavLink: {
    borderBottom: "2px solid transparent",
    paddingBottom: theme.spacing(0.5),
    textDecoration: "none",
  },
  publicNavText: {
    color: "rgba(255, 255, 255, 0.74)",
    fontFamily: '"Manrope", sans-serif',
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  },
  publicActionLink: {
    background: "rgba(255, 255, 255, 0.04)",
    border: "1px solid rgba(255, 255, 255, 0.16)",
    borderRadius: 999,
    padding: theme.spacing(0.55, 1.25),
    textDecoration: "none",
  },
  publicActionText: {
    color: "rgba(255, 255, 255, 0.72)",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "0.8rem",
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  branchTrigger: {
    alignItems: "center",
    background: "rgba(255, 255, 255, 0.04)",
    border: "1px solid rgba(255, 255, 255, 0.18)",
    borderRadius: 999,
    color: "var(--wws-paper)",
    cursor: "pointer",
    display: "inline-flex",
    gap: theme.spacing(0.9),
    marginLeft: theme.spacing(1),
    padding: theme.spacing(0.55, 1.25),
  },
  branchInfoGroup: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.85),
    marginLeft: theme.spacing(1),
  },
  branchTriggerLabel: {
    color: "rgba(255, 255, 255, 0.64)",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "0.7rem",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  branchTriggerValue: {
    color: "var(--wws-paper)",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "0.84rem",
    fontWeight: 800,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  branchTriggerIcon: {
    color: "rgba(255, 255, 255, 0.78)",
    fontSize: "1.1rem",
  },
  branchTimeBadge: {
    display: "inline-flex",
    alignItems: "center",
    minHeight: 34,
    padding: theme.spacing(0.45, 1.05),
    borderRadius: 999,
    background: "rgba(255, 255, 255, 0.08)",
    border: "1px solid rgba(255, 255, 255, 0.16)",
    color: "rgba(255, 255, 255, 0.78)",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "0.76rem",
    fontWeight: 800,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  branchMenuPaper: {
    border: "1px solid rgba(19, 63, 144, 0.12)",
    borderRadius: 14,
    boxShadow: "0 16px 36px rgba(7, 25, 64, 0.16)",
    marginTop: theme.spacing(1),
    minWidth: 170,
  },
  branchMenuItem: {
    fontFamily: '"Manrope", sans-serif',
    fontWeight: 700,
    minHeight: 42,
  },
  branchDialogPaper: {
    background: "linear-gradient(180deg, #f7faff 0%, #edf4ff 100%)",
    border: "1px solid rgba(21, 69, 158, 0.14)",
    borderRadius: 28,
    boxShadow: "0 24px 60px rgba(8, 28, 74, 0.2)",
    maxWidth: 520,
    overflow: "hidden",
    width: "calc(100vw - 32px)",
  },
  branchDialogTitle: {
    color: "var(--wws-primary)",
    fontFamily: '"Barlow Condensed", sans-serif',
    fontSize: "2rem",
    fontWeight: 700,
    letterSpacing: "0.04em",
    padding: theme.spacing(3, 3, 1.5),
    textTransform: "uppercase",
  },
  branchDialogContent: {
    padding: theme.spacing(0, 3, 1),
  },
  branchDialogText: {
    color: "rgba(24, 46, 84, 0.78)",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "1rem",
    lineHeight: 1.6,
  },
  branchDialogActions: {
    gap: theme.spacing(1.25),
    justifyContent: "flex-end",
    padding: theme.spacing(1, 3, 3),
  },
  branchDialogPrimaryButton: {
    background: "var(--wws-primary)",
    border: "1px solid rgba(21, 69, 158, 0.2)",
    borderRadius: 999,
    color: "#fff",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "0.82rem",
    fontWeight: 800,
    letterSpacing: "0.08em",
    minWidth: 148,
    padding: theme.spacing(1, 2.3),
    textTransform: "uppercase",
    "&:hover": {
      background: "#113f90",
    },
  },
  branchDialogSecondaryButton: {
    background: "#fff",
    border: "1px solid rgba(21, 69, 158, 0.16)",
    borderRadius: 999,
    color: "var(--wws-primary)",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "0.82rem",
    fontWeight: 800,
    letterSpacing: "0.08em",
    minWidth: 112,
    padding: theme.spacing(1, 2.1),
    textTransform: "uppercase",
  },
  privateActionLink: {
    marginLeft: theme.spacing(2),
    background: "rgba(255, 255, 255, 0.04)",
    border: "1px solid rgba(255, 255, 255, 0.18)",
    borderRadius: 999,
    padding: theme.spacing(0.55, 1.25),
    textDecoration: "none",
  },
  privateActionText: {
    color: "rgba(255, 255, 255, 0.72)",
    fontFamily: '"Manrope", sans-serif',
    fontSize: "0.8rem",
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  [theme.breakpoints.down("lg")]: {
    privateBrand: {
      flexBasis: "100%",
    },
    privateToolbar: {
      columnGap: theme.spacing(2),
      rowGap: theme.spacing(1.5),
    },
    navLinkText: {
      marginLeft: 0,
      whiteSpace: "nowrap",
    },
    branchInfoGroup: {
      flexWrap: "wrap",
      marginLeft: 0,
      maxWidth: "100%",
    },
    privateActionLink: {
      marginLeft: 0,
      flexShrink: 0,
    },
  },
  [theme.breakpoints.down("sm")]: {
    portalBrand: {flex:"1 1 auto",minWidth:48},
    logoIcon: {width:48,padding:3,boxSizing:"border-box"},
    portalMasthead: {padding:"10px 12px",gap:8},
    portalBranchGroup: {minWidth:0,flexShrink:1},
    branchTriggerLabel: {display:"none"},
    publicToolbar: {
      alignItems: "flex-start",
      flexDirection: "column",
    },
    publicNav: {
      flexWrap: "wrap",
      gap: theme.spacing(1.5),
      marginLeft: 0,
    },
    publicTitle: {
      fontSize: "1.25rem",
    },
    navLinkText: {
      marginLeft: 0,
    },
    branchInfoGroup: {
      marginLeft: 0,
      flexWrap: "wrap",
    },
    branchTrigger: {
      marginLeft: 0,
      minHeight:44,
      gap:6,
      padding:"6px 10px",
      whiteSpace:"nowrap",
    },
    privateActionLink: {
      marginLeft: 0,
    },
  },
});

export default styles;
